module.exports = __webpack_public_path__ + "static/media/contact_tagline_handwriting.470f06df.svg";